import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import SearchContainer from "../containers/SearchContainer";
import FilterContainer from "../containers/FilterContainer";
import JobContainer from "../containers/JobContainer";
import MapContainer from "../containers/MapContainer";
import qs from "qs";

const LeftView = styled.div`
  position: absolute;
  width: 21.429em;
  left: 1.429em;
  top: 2.143em;
  z-index: 50;
`;

const SearchView = styled.div`
  position: absolute;
  width: 270px;
  right: 1.429em;
  top: 2.143em;
  z-index: 50;
`;


const App = ({ match, location }) => {
  const endpoint = qs.parse(location.search, { ignoreQueryPrefix: true }).endpoint || "https://routing-engine.afi.io";

  return (
    <div>
      <LeftView>
        <JobContainer jobId={match.params.id} endpoint={endpoint}/>
        <FilterContainer />
      </LeftView>
      <SearchView>
        <SearchContainer />
      </SearchView>
      <MapContainer />
    </div>
  );
};

App.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js